import apiInstance from "../api";
import endPoints from "../endpoints";

export const GetTradingPartner = (id) => {
  return apiInstance().get(`${endPoints.plan.getClearingPartner}/${id}`);
};
export const GetTradingPartnerList = (id) => {
  return apiInstance().get(`${endPoints.plan.getAllClearingPartners}`);
};
export const GetPlanTradingPartnerList = (id) => {
  return apiInstance().get(
    `${endPoints.plan.getPlanAssociatedClearingPartners}/${id}`
  );
};
export const GetInvestmentTradingPartnerList = (id) => {
  return apiInstance().get(
    `${endPoints.plan.getInvestmentAssociatedClearingPartner}/${id}`
  );
};
export const DeleteClearingPartner = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteClearingPartner}/${id}`);
};
export const DeleteClearanceTime = (id) => {
  return apiInstance().delete(`${endPoints.plan.deleteClearanceTime}/${id}`);
};
export const UpsertPlanWithClearingPartner = (data) => {
  return apiInstance().post(`${endPoints.plan.addClearingPartnerToPlan}`, data);
};
export const UpsertClearingPartner = (data) => {
  return apiInstance().post(`${endPoints.plan.upsertClearingPartner}`, data);
};
export const UpsertInvestmentWithClearingPartner = (data) => {
  return apiInstance().post(
    `${endPoints.plan.saveInvestmentAssociatedClearingPartner}`,
    data
  );
};
export const UpsertClearanceTime = (data) => {
  return apiInstance().post(`${endPoints.plan.upsertClearanceTime}`, data);
};
export const getClearingPartnerAccountPlans = (data) => {
  return apiInstance().get(
    `${endPoints.plan.getClearingPartnerAccountPlans}/${data}`
  );
};
export const getClearingPartnerPlans = (data) => {
  return apiInstance().get(`${endPoints.plan.getClearingPartnerPlans}/${data}`);
};
export const getAllAdvisors = () => {
  return apiInstance().get(`${endPoints.plan.getAllMasterAdvisors}`);
};
export const getAdvisorOrganisation = (id) => {
  return apiInstance().get(`${endPoints.plan.getAdvisor}/${id}`);
};
export const getAdvisorOrganisationPlans = (id) => {
  return apiInstance().get(`${endPoints.plan.getAdvisoPlans}/${id}`);
};
export const getAdvisorRepresentativePlans = (id) => {
  return apiInstance().get(
    `${endPoints.plan.getAdvisorRepresentativePlans}/${id}`
  );
};
export const getPlansWithAdvisorRepresentative = (id) => {
  return apiInstance().get(
    `${endPoints.plan.getPlansAssociatedWithAdvisorRepresentative}/${id}`
  );
};
export const getInvestmentWithAdvisorRepresentative = (id) => {
  return apiInstance().get(
    `${endPoints.plan.getInvestmentAssociatedAdvisorRepresentative}/${id}`
  );
};
export const UpsertAdvisorRepresentative = (data) => {
  return apiInstance().post(
    `${endPoints.plan.upsertAdvisorRepresentative}`,
    data
  );
};
export const UpsertAdvisorRepresentativeToPlan = (data) => {
  return apiInstance().post(`${endPoints.plan.upsertAdvisorToPlan}`, data);
};
export const UpsertAdvisorRepresentativeToInvestment = (data) => {
  return apiInstance().post(
    `${endPoints.plan.upsertAdvisorRepresentativeToInvestment}`,
    data
  );
};
export const DeleteAdvisorRepresentative = (id) => {
  return apiInstance().delete(
    `${endPoints.plan.deleteAdvisorRepresentative}/${id}`
  );
};

// export const GetTradingPartner = (id) => {
//   return apiInstance().get(`${endPoints.master.getTradingPartner}/${id}`);
// };
